import React, { useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import ExecutiveDevices from './components/ChapterSubject/ExecutiveDevices.js';

const ChaptersSubjectCodes = () => {
  return (
    <>
      <Breadcrumb pageName="ابواب و فصول کدهای موضوعی" />
      <ExecutiveDevices />
    </>
  );
};

export default ChaptersSubjectCodes;
